import React, { useEffect, createRef } from 'react';
import styles from './styles.scss';
import { Col, Row } from 'Components/Grid';

const FormErrorMessage = ({ errors }) => {
  if (!Object.keys(errors).length) return null;

  const paragraphRef = createRef(null);

  useEffect(() => {
    paragraphRef.current.setAttribute('tabindex', '-1');
    paragraphRef.current.focus();
  }, []);

  return (
    <Row>
      <Col>
        <p ref={paragraphRef} className={styles.formError} aria-live="polite" role="alert">
          <br />
          <br />
          Bitte prüfen Sie Ihre Formulareingaben
        </p>
      </Col>
    </Row>
  );
};

export default FormErrorMessage;
